export default __webpack_public_path__ + "static/media/arrow-left.291ba6be.svg";